import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { AddOutline } from 'antd-mobile-icons'
import Header from '../../components/FormTools/FormHeader'
import { InfiniteScroll, List } from 'antd-mobile-v5'
import { useGetStoreAppsList } from '../../services/hooks'
import { useLanguage } from '../../services/hooks/user'
import { useIntl } from 'react-intl'
import { storeLevel } from '../../components/common/StoreLevel'
import InfiniteScrollContent from '../../components/FormTools/InfiniteScrollContent'

const StoreAppsList = () => {
  const lang = useLanguage()
  const { push } = useHistory()
  const { formatMessage } = useIntl()
  const [page, setPage] = useState(1)
  const [list, setList] = useState([])
  const [hasMore, setHasMore] = useState(true)
  const { runAsync } = useGetStoreAppsList(page)

  async function loadMore() {
    setHasMore(true)
    const append = await runAsync(page)
    setList((val) => [...val, ...append.content])
    setHasMore(page < append.totalPages)
    setPage(page + 1)
  }

  const getTypeIntl = (type) => {
    const currentType = storeLevel.find((item) => item['name_en'] === type)
    return currentType[`name_${lang}`]
  }

  return (
    <>
      <Header
        text={formatMessage({ id: 'store-apps' })}
        type={'list'}
        rightContent={<AddOutline fontSize={24} onClick={() => push('/store_apps', { detail: null })} />}
      />
      <List>
        {list.map((item) => (
          <List.Item
            title={formatMessage({ id: 'si-app-number' }) + item.code}
            clickable
            onClick={() => push(`/store_apps?code=${item.code}`, { detail: item })}
          >
            {getTypeIntl(item.type)}
          </List.Item>
        ))}
      </List>
      <InfiniteScroll loadMore={loadMore} hasMore={hasMore} threshold={300}>
        {(hasMore, failed, retry) => <InfiniteScrollContent hasMore={hasMore} failed={failed} onRetry={retry} />}
      </InfiniteScroll>
    </>
  )
}

export default StoreAppsList
